import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useTranslation } from 'react-i18next';

const Commercial = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen">
      <Header />

      {/* Breadcrumb */}
      <div className="bg-gray-100 py-4">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-sm text-gray-600">
            <a href="/" className="text-blue-500 hover:underline">AP Pacific</a> &gt; {t('commercial.breadcrumb')}
          </div>
        </div>
      </div>

      {/* Page Header */}
      <div className="bg-white py-12">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-4xl font-bold text-gray-800">{t('commercial.pageTitle')}</h1>
        </div>
      </div>

      {/* Services Provided Section */}
      <section className="py-8 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">{t('commercial.serviceProvided')}</h2>
          <ul className="space-y-3">
            <li className="flex items-center">
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-4"></span>
              <a href="/service/commercial-carpet-cleaning" className="text-blue-500 hover:underline font-medium">
                {t('commercial.services.cleaning')}
              </a>
            </li>
            <li className="flex items-center">
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-4"></span>
              <a href="/service/grout-tile-cleaning" className="text-blue-500 hover:underline font-medium">
                {t('commercial.services.grout')}
              </a>
            </li>
            <li className="flex items-center">
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-4"></span>
              <a href="/service/upholstery-cleaning" className="text-blue-500 hover:underline font-medium">
                {t('commercial.services.upholstery')}
              </a>
            </li>
            <li className="flex items-center">
              <span className="w-2 h-2 bg-blue-500 rounded-full mr-4"></span>
              <a href="/service/flood-emergency-water-damage" className="text-blue-500 hover:underline font-medium">
                {t('commercial.services.flood')}
              </a>
            </li>
          </ul>
          <div className="mt-8">
            <p className="text-lg font-bold text-gray-800">
              {t('commercial.moreInfo')}
            </p>
          </div>
        </div>
      </section>

      {/* Commercial Cleaning Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-3xl font-bold text-gray-800 mb-8">{t('commercial.cleaningTitle')}</h2>

          {/* Commercial Equipment Image */}
          <div className="mb-8">
            <img
              src="https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_2414-scaled.jpg"
              alt="Professional carpet cleaning equipment"
              className="w-full max-w-2xl rounded-lg shadow-lg"
            />
          </div>

          <div className="prose max-w-none mb-12">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              {t('commercial.cleaningText')}
            </p>
          </div>

          {/* Emergency Flood Services */}
          <div className="mb-8">
            <img
              src="https://landing.it-tech.name/wp-content/uploads/2025/11/IMG_20251101_124858-3-scaled.jpg"
              alt="Emergency flood cleanup equipment"
              className="w-full max-w-2xl rounded-lg shadow-lg"
            />
          </div>

          <div className="mb-12">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">{t('commercial.floodTitle')}</h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              {t('commercial.floodText')}
            </p>
          </div>

          {/* Call to Action */}
          <div className="text-center">
            <a
              href="/contact"
              className="inline-block bg-blue-500 text-white font-bold px-8 py-3 rounded-full hover:bg-blue-600 transition-colors"
            >
              {t('commercial.ctaButton')}
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Commercial;
